/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

import { REVIEW_FEEDBACK_FRAGMENT } from '@dai/graphql'

export const DETECTION_IMAGE = gql`
  query DetectionImage($imageId: ID!) {
    detectionImage(imageId: $imageId) {
      __typename
      ... on DetectionImageSession {
        canEdit
        statusMessage
        returnedFeedbackCount
        reviewFeedback {
          ...ReviewFeedbackFields
        }
        image {
          id
          imageUrl
          isFlagged
          flagged {
            level
            moreInfo
            reasons {
              type
              reason
              resolved
            }
          }
          leasedById
          leasedAt
          boundingBoxes {
            id
            sourceImageUrl
            minX
            maxX
            minY
            maxY
            metaClass
            tag
            tagId
            isHumanAdded
            isHumanDeleted
            leasedById
            leasedAt
          }
        }
      }
      ... on NoItemsAvailableError {
        code
        message
      }
    }
  }
  ${REVIEW_FEEDBACK_FRAGMENT}
`
